const uploadImageActivity = {
  name: 'uploadImage',
  value: 'UploadImage',
};

const createAdActivity = {
  name: 'createAds',
  value: 'CreateAds',
};

export const schema = {
  scenario: [
    {
      name: 'aimCampaignCreationWizard',
      value: 'AimCampaignCreationWizard',
      activity: [
        {
          name: 'createCampaignSettings',
          value: 'CreateCampaignSettings',
        },
        {
          name: 'createAudienceTargets',
          value: 'CreateAudienceTargets',
        },
        {
          name: 'createAdGroup',
          value: 'CreateAdGroup',
        },
        createAdActivity,
        {
          name: 'createBudgetBids',
          value: 'CreateBudgetBids',
        },
        uploadImageActivity,
        {
          name: 'wizardActivity',
          value: 'WizardActivity',
        },
      ],
    },
    {
      name: 'aimShoppingCampaignCreationWizard',
      value: 'AimShoppingCampaignCreationWizard',
      activity: [
        {
          name: 'bmcRedirect',
          value: 'BMCRedirect',
        },
        {
          name: 'createCampaignSettings',
          value: 'CreateCampaignSettings',
        },
        {
          name: 'createAdGroup',
          value: 'CreateAdGroup',
        },
        {
          name: 'createAudienceTargets',
          value: 'CreateAudienceTargets',
        },
        {
          name: 'createBudgetBids',
          value: 'CreateBudgetBids',
        },
        {
          name: 'wizardActivity',
          value: 'WizardActivity',
        },
      ],
    },
    {
      name: 'aimAdGroupCreationWizard',
      value: 'AimAdGroupCreationWizard',
      activity: [
        {
          name: 'createAdGroupBasic',
          value: 'CreateAdGroupBasic',
        },
        {
          name: 'createAdGroup',
          value: 'CreateAdGroup',
        },
        {
          name: 'createAudienceTargets',
          value: 'CreateAudienceTargets',
        },
        createAdActivity,
        uploadImageActivity,
      ],
    },
    {
      name: 'aimShoppingAdGroupCreationWizard',
      value: 'AimShoppingAdGroupCreationWizard',
      activity: [
        {
          name: 'createAdGroupBasic',
          value: 'CreateAdGroupBasic',
        },
        {
          name: 'createAdGroup',
          value: 'CreateAdGroup',
        },
        {
          name: 'createAudienceTargets',
          value: 'CreateAudienceTargets',
        },
      ],
    },
    {
      name: 'aimAdGroupSettingsWizard',
      value: 'AimAdGroupSettingsWizard',
      activity: [
        {
          name: 'saveSettings',
          value: 'SaveSettings',
        },
        {
          name: 'loadSettings',
          value: 'LoadSettings',
        },
      ],
    },
    {
      name: 'aimAdCreation',
      value: 'aimAdCreation',
      activity: [
        createAdActivity,
        uploadImageActivity,
      ],
    },
    {
      name: 'aimAdEdit',
      value: 'aimAdEdit',
      activity: [
        createAdActivity,
        uploadImageActivity,
      ],
    },
    {
      name: 'aimAdGroupCriterionCreationScenario',
      value: 'aimAdGroupCriterionCreationScenario',
      activity: [
        {
          name: 'createCriterion',
          value: 'CreateCriterion',
        },
      ],
    },
    {
      name: 'simplifiedCampaignCreationWizard',
      value: 'simplifiedCampaignCreationWizard',
      activity: [
        {
          name: 'campaignSetting',
          value: 'CampaignSetting',
        },
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
        {
          name: 'summary',
          value: 'Summary',
        },
      ],
    },
  ],
};
